import _find from 'lodash/find';
import addGroupRegisterTemplate from './../add-group-register/add-group-register.html';
import editGroupRegisterTemplate from './../edit-group-register/edit-group-register.html';

export default class GroupRegisterViewController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    groupRegisterRecords,
    studentId,
    groups,
    StudentService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.groupRegisterRecords = groupRegisterRecords;
    this.studentId = studentId;
    this.groups = groups;
    this.StudentService = StudentService;
    this.isDirty = false;
  }

  add(ev) {
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'AddGroupRegisterController',
      template: addGroupRegisterTemplate,
      locals: {
        groups: this.groups,
        studentId: this.studentId
      },
      clickOutsideToClose: true,
      targetEvent: ev,
      multiple: true
    })
      .then(() => {
        this.isDirty = true;
        this.getAllGroupsRegisterRecords();
        this.StudentService.getAll();
      }, () => {});
  }

  edit(id, ev) {
    const groupsRegisterRecord = _find(this.groupRegisterRecords, group => group.id === id);
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'EditGroupRegisterController',
      template: editGroupRegisterTemplate,
      locals: {
        groups: this.groups,
        studentId: this.studentId,
        groupsRegisterRecord
      },
      clickOutsideToClose: true,
      targetEvent: ev,
      multiple: true
    })
      .then(() => {
        this.isDirty = true;
        this.getAllGroupsRegisterRecords();
      }, () => {});
  }

  remove(id) {
    this.StudentService.deleteGroupsRegisterRecord(this.studentId, id)
      .then(() => {
        this.isDirty = true;
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Usunięto wpis')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  getAllGroupsRegisterRecords() {
    this.StudentService.getGroupsRegisterRecords(this.studentId).then(result => {
      result.forEach((item, idx) => {
        item.primary = idx === 0;
      });
      this.groupRegisterRecords = result;
    });
  }

  cancel() {
    if (this.isDirty) {
      this.$mdDialog.hide();
    }

    this.$mdDialog.cancel();
  }
}
